// Regional shipping table (GBP). Free shipping over the threshold.
// Regions map roughly by cost tier: UK £15, EU £20, Rest of World £30.

export const FREE_SHIPPING_THRESHOLD = 150;

const UK_RATE = 15;
const EU_RATE = 20;
const ROW_RATE = 30;

// Country → tier mapping. Kept explicit for the most common destinations; anything
// not listed defaults to Rest of World.
const EU_COUNTRIES = new Set([
    "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Denmark",
    "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland",
    "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands",
    "Norway", "Poland", "Portugal", "Romania", "Slovakia", "Slovenia", "Spain",
    "Sweden", "Switzerland", "Iceland",
]);

// Ordered list surfaced in the checkout country dropdown.
export const SHIPPING_COUNTRIES = [
    { name: "United Kingdom", tier: "uk", rate: UK_RATE },
    // EU / EEA
    ...[
        "Ireland", "France", "Germany", "Netherlands", "Belgium", "Spain",
        "Portugal", "Italy", "Austria", "Denmark", "Sweden", "Norway",
        "Finland", "Poland", "Greece", "Czechia", "Hungary", "Romania",
        "Switzerland", "Iceland",
    ].map((n) => ({ name: n, tier: "eu", rate: EU_RATE })),
    // Rest of World
    ...[
        "United States", "Canada", "Australia", "New Zealand", "United Arab Emirates",
        "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Israel", "Turkey",
        "Japan", "South Korea", "Singapore", "Hong Kong", "Malaysia", "Indonesia",
        "Philippines", "India", "South Africa", "Mexico", "Brazil", "Argentina",
        "Chile", "Colombia", "Other",
    ].map((n) => ({ name: n, tier: "row", rate: ROW_RATE })),
];

export function shippingCostFor(country, subtotal) {
    if (subtotal >= FREE_SHIPPING_THRESHOLD) return 0;
    if (!country || country === "United Kingdom") return UK_RATE;
    if (EU_COUNTRIES.has(country)) return EU_RATE;
    return ROW_RATE;
}
